import { useCallback, useState } from 'react';

import { type CategoryNode } from '@/views/build/features/category-tree';

import { type PublisherFormValues } from '../types';
import { findPublisherNodeById } from '../utils';

export const useSelectPublisher = ({
  publisherNodes,
  publisherFormValues,
}: {
  publisherNodes: CategoryNode[];
  publisherFormValues: PublisherFormValues;
}) => {
  const [selectedPublisherNode, setSelectedPublisherNode] = useState<
    CategoryNode | undefined
  >(() => findPublisherNodeById(publisherNodes, publisherFormValues.publisher));

  const selectPublisher = useCallback((publisherNode?: CategoryNode) => {
    setSelectedPublisherNode(publisherNode);
  }, []);

  return [selectedPublisherNode, selectPublisher] as const;
};
